import React from 'react';
import PropTypes from 'prop-types';
import Money from '../../money';

const ItemBreakdown = ({ item }) => (
  <div className="o-tableize">
    <div className="o-tableize__row">
      <div className="o-tableize__cell u-pr-">Cost</div>
      <div className="o-tableize__cell u-text-right u-pl">
        <Money automationId="text:itemCost">{item.cost}</Money>
      </div>
    </div>
    <div className="o-tableize__row u-pr-" display-if={item.tipAmount}>
      <div className="o-tableize__cell">Tips</div>
      <div className="o-tableize__cell u-text-right u-pl">
        <Money automationId="text:tipAmount">{item.tipAmount}</Money>
      </div>
    </div>
    <div className="o-tableize__row u-pr-" display-if={item.tax}>
      <div className="o-tableize__cell">Tax</div>
      <div className="o-tableize__cell u-text-right u-pl">
        <Money automationId="text:taxAmount">{item.tax}</Money>
      </div>
    </div>
    <div className="o-tableize__row u-pr-" display-if={item.discountAmounts + item.promoAmounts}>
      <div className="o-tableize__cell">Promo/Discount</div>
      <div className="o-tableize__cell u-text-right u-co-red u-pl">
        <Money automationId="text:promoDiscountAmount">{item.discountAmounts + item.promoAmounts}</Money>
      </div>
    </div>
    <div className="o-tableize__row u-pr-" display-if={item.refundedCost}>
      <div className="o-tableize__cell">Refunded Cost</div>
      <div className="o-tableize__cell u-text-right u-co-red u-pl">
        <Money automationId="text:refundedCostAmount">{item.refundedCost}</Money>
      </div>
    </div>
    <div className="o-tableize__row u-pr-" display-if={item.refundedTip}>
      <div className="o-tableize__cell">Refunded Tip</div>
      <div className="o-tableize__cell u-text-right u-co-red u-pl">
        <Money automationId="text:refundedTipAmount">{item.refundedTip}</Money>
      </div>
    </div>
    <div className="o-tableize__row u-pr-" display-if={item.refundedTax}>
      <div className="o-tableize__cell">Refunded Tax</div>
      <div className="o-tableize__cell u-text-right u-co-red u-pl">
        <Money automationId="text:refundedTaxAmount">{item.refundedTax}</Money>
      </div>
    </div>
    <div className="o-tableize__row u-pr-">
      <div className="o-tableize__cell u-border-top">Total</div>
      <div className="o-tableize__cell u-border-top u-text-right u-pl">
        <Money automationId="text:totalCostAmount">{item.totalCost}</Money>
      </div>
    </div>
    <div className="o-tableize__row u-pr-" display-if={item.giftCardAmount}>
      <div className="o-tableize__cell">GC</div>
      <div className="o-tableize__cell u-text-right u-pl">
        <Money automationId="text:giftCardAmount">{item.giftCardAmount}</Money>
      </div>
    </div>
  </div>
);
ItemBreakdown.propTypes = {
  item: PropTypes.shape({
    cost: PropTypes.number,
    tipAmount: PropTypes.number,
    tax: PropTypes.number,
    promoAmounts: PropTypes.number,
    discountAmounts: PropTypes.number,
    refundedAmount: PropTypes.number,
    totalCost: PropTypes.number,
    giftCardAmount: PropTypes.number,
  }).isRequired,
};

export default ItemBreakdown;
